import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterCount',
})
export class FilterCountPipe implements PipeTransform {
  transform(value: number): string {
    if (value > 99) return '99+';

    return value?.toString();
  }
}
